/**
 * Scroll into current section of page or root element
 * @param {string} view id/class name to scroll into
 */

export const scrollIntoView = (
  view?: string,
  // eslint-disable-next-line no-undef
  scrollIntoViewOptions?: ScrollIntoViewOptions
): void => {
  if (!document) return;

  const app = document.querySelector(view || "#__next");
  if (app) app.scrollIntoView({ ...scrollIntoViewOptions, behavior: "smooth" });
};
